const currencySymbols = {
	EUR: '€',
	USD: '$',
	GBP: '£'
};
let originalCartPopupTemplate = null;
const normalizeSeparators = (str) => str.replace(/[–—]/g, '-');
window.allowRenderTrainingOccurrences = true;
const ORIGINAL_CART_TEMPLATE = getCartPopupTemplate();

function getCookie(name) {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	return match ? match[2] : null;
}

function saveCart(cart) {
	const json = JSON.stringify(cart);
	const encoded = btoa(encodeURIComponent(json));
	document.cookie = `_cart_=${encoded}; path=/; max-age=${60 * 60 * 24}; SameSite=Lax; secure`;
}

function getCart() {
	const cookie = document.cookie.split('; ').find(row => row.startsWith('_cart_='));
	if (!cookie) return {};
	const encoded = cookie.split('=')[1];
	try {
		const decoded = decodeURIComponent(atob(encoded));
		const cart = JSON.parse(decoded);
		return typeof cart === 'object' ? cart : {};
	} catch (e) {
		return {};
	}
}

function addToCart(trainingId, locationId, eventId, allLocations = '', eventDate = '') {
	const tId = trainingId.toString();
	const lId = locationId.toString();
	const eId = eventId.toString();
	const aLoc = allLocations.toString();
	const date = eventDate.toString();
	
	let cart = getCart();
	if (!cart[tId]) cart[tId] = {};
	if (!cart[tId][lId]) cart[tId][lId] = [];
	
	const uid = `${tId}-${lId}-${Date.now()}`;
	
	const entry = {
		id: eId,
		all_locations: aLoc,
		uid: uid
	};
	
	if (date) entry.date = date;
	
	const alreadyExists = cart[tId][lId].some(item => item.uid === uid);
	if (!alreadyExists) cart[tId][lId].push(entry);
	
	saveCart(cart);
	
	return uid;
}

function updateCartMiniQuantity(cart = null) {
	cart = cart || getCart();
	let count = 0;
	
	Object.values(cart).forEach(course => {
		if (course && typeof course === 'object') {
			Object.values(course).forEach(items => {
				if (Array.isArray(items)) {
					count += items.length;
				}
			});
		}
	});
	
	const el = document.querySelector('.cart-mini__quantity');
	if (el) {
		el.textContent = '';
		el.textContent = count;
	}
	
	const el2 = document.querySelector('.body-mini-cart__total');
	if (el2) {
		el2.textContent = '';
		el2.textContent = count + ' courses';
	}
	
}

function parseDateRange(rawDate) {
	if (!rawDate) {
		const now = new Date();
		const future = new Date(now);
		future.setMonth(future.getMonth() + 3);
		return [now.toISOString().split('T')[0], future.toISOString().split('T')[0]];
	}
	
	rawDate = normalizeSeparators(rawDate);
	
	if (!rawDate.includes(' - ')) {
		console.warn('Unexpected date format:', rawDate);
		return ['', ''];
	}
	
	const [rawStart, rawEnd] = rawDate.split(' - ');
	
	const parseDMY = (str) => {
		const [day, month, year] = str.split('-').map(Number);
		return new Date(year, month - 1, day);
	};
	
	const startDate = parseDMY(rawStart);
	const endDate = parseDMY(rawEnd);
	
	return [startDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0]];
}

function getSelectedLocations(selectEl) {
	return Array.from(selectEl.selectedOptions || [])
		.filter(option => !option.classList.contains('country-option'))
		.map(option => option.value)
		.filter(Boolean);
}

function getCheckedFilterLocations(container = document) {
	return Array.from(container.querySelectorAll('input[type="checkbox"]:checked'))
		.filter(cb => !cb.id.startsWith('country_'))
		.map(cb => cb.value);
}

function syncCountriesFromLocations() {
	document.querySelectorAll('#booking-popup .sidebar-filters__block').forEach(block => {
		const countryCb = block.querySelector('input[id^="country_"]');
		const locCheckboxes = block.querySelectorAll('input[id^="loc_"]');
		if (!countryCb || !locCheckboxes.length) return;
		countryCb.checked = Array.from(locCheckboxes).every(cb => cb.checked);
	});
}

function setLoaderState(loader, active) {
	if (loader) loader.classList.toggle('active', active);
}

function getCartPopupTemplate() {
	if (!originalCartPopupTemplate) {
		const popupBody = document.querySelector('.item-cart-added__body');
		originalCartPopupTemplate = popupBody.innerHTML;
	}
	return originalCartPopupTemplate;
}

function addMiniCartItem(data) {
	const container = document.querySelector('.header__cart .body-mini-cart__items');
	if (!container || !data) return;
	
	const item = document.createElement('div');
	item.className = 'body-mini-cart__item';
	
	const courseName = data.title ?? 'Course';
	const locationName = data.location_name ?? 'Location';
	const date = data.start_date ? new Date(data.start_date) : null;
	const formattedDate = date ? date.toLocaleDateString('en-US', {
		weekday: 'short',
		day: 'numeric',
		month: 'short'
	}) : '';
	
	item.dataset.courseId = data.trainingId ?? '';
	item.dataset.locationId = data.locationId ?? '';
	item.dataset.eventId = data.eventId ?? '';
	item.dataset.uid = data.uid ?? '';
	item.dataset.offerToken = data.offerToken ?? '';
	
	item.innerHTML = `
		<div class="body-mini-cart__row">
			<h3 class="body-mini-cart__label">
				<span class="body-mini-cart__remove">
					<img src="${global.template_url}/dist/img/icons/remove.svg" width="20" height="20" />
				</span>
				${courseName}
			</h3>
			<div class="body-mini-cart_counter">
				<div data-quantity class="quantity">
					<button data-quantity-minus type="button" class="quantity__button quantity__button_minus">
						<svg width="16" height="16">
							<use xlink:href="${global.template_url}/dist/img/icons/icons.svg#minus"></use>
						</svg>
					</button>
					<div class="quantity__input">
						<input data-quantity-value autocomplete="off" type="text" name="form[]" value="1" />
					</div>
					<button data-quantity-plus type="button" class="quantity__button quantity__button_plus">
						<svg width="16" height="16">
							<use xlink:href="${global.template_url}/dist/img/icons/icons.svg#plus"></use>
						</svg>
					</button>
				</div>
			</div>
		</div>
		<div class="body-mini-cart__row">
			<div class="body-mini-cart__address">
				<svg width="16" height="16">
					<use xlink:href="${global.template_url}/dist/img/icons/icons.svg#pin"></use>
				</svg>
				<span>${locationName}</span>
			</div>
			<div class="body-mini-cart__address">${formattedDate}</div>
		</div>
	`;
	
	container.appendChild(item);
	
	const tokenMatch = data.booking_url?.match(/tokens=([^&]+)/);
	const token = tokenMatch ? tokenMatch[1] : '';
	if (!token) return;
	
	const btn = document.querySelector('.body-mini-cart__button');
	if (!btn || !btn.href) return;
	
	try {
		const url = new URL(btn.href);
		const existingTokens = url.searchParams.get('tokens')?.split(',').filter(Boolean) ?? [];
		
		if (!existingTokens.includes(token)) {
			existingTokens.push(token);
			url.searchParams.set('tokens', existingTokens.join(','));
		}
		
		// Set or overwrite country only once, from .wrapper[data-country]
		const wrapperCountry = document.querySelector('.wrapper')?.dataset?.country;
		if (wrapperCountry) url.searchParams.set('country', wrapperCountry);
		
		btn.href = url.toString();
	} catch (e) {
		console.warn('Invalid booking URL:', e);
	}
}

function renderCartPopupTemplate(data, elearning) {
	const popup = document.querySelector('.item-cart-added');
	const popupBody = document.querySelector('.item-cart-added__body');
	if (!popup || !popupBody) return;
	
	let html = ORIGINAL_CART_TEMPLATE;
	
	Object.keys(data).forEach(key => {
		html = html.replaceAll(`{{${key}}}`, data[key] ?? '');
	});
	popupBody.innerHTML = html;
	
	const bookingBtn = popup.querySelector('a.booking-url');
	if (bookingBtn && data.booking_url) {
		bookingBtn.setAttribute('href', data.booking_url);
	}
	
	popup.classList.toggle('elearning', !!elearning);
	
	popupBody.querySelectorAll('[data-src]').forEach(el => {
		el.setAttribute('src', el.getAttribute('data-src'));
		el.removeAttribute('data-src');
	});
}

function handleBooking(bookBtn) {
	bookBtn.addEventListener('click', function (e) {
		if (!bookBtn || bookBtn.disabled || bookBtn.classList.contains('button--disabled')) return;
		const row = bookBtn.closest('.course-order-row');
		if (!row) return;
		
		const popup = document.querySelector('.item-cart-added');
		const popupLoader = popup.querySelector('.loader-wrp');
		if (popupLoader) popupLoader.classList.remove('active');
		
		const main = document.querySelector('main.page--single-course');
		const trainingId = main?.dataset?.courseId || '';
		const locationId = row.dataset.locationId || '';
		const eventId = row.dataset.eventId || '';
		const allLocations = row.dataset.allLocations || '';
		
		const country = document.querySelector('.wrapper')?.dataset?.country || '';
		const booking_url = `https://booking-form2025.fmtcstaging.nl/?tokens=${row.dataset.offerToken}&country=${country}`;
		
		const data = {
			title: main?.dataset?.courseTitle || '',
			location_name: row.dataset.locationName || '',
			country_code: row.dataset.countryCode || '',
			start_date: row.dataset.startDate || '',
			end_date: row.dataset.endDate || '',
			currency: row.dataset.currency || '',
			price: row.dataset.price || '',
			trainingId,
			locationId,
			eventId,
			booking_url: booking_url,
			offerToken: row.dataset.offerToken
		};
		
		let uid = addToCart(trainingId, locationId, eventId, allLocations);
		data.uid = uid;
		
		renderCartPopupTemplate(data, false);
		addMiniCartItem(data);
		updateCartMiniQuantity();
		
		bookBtn.classList.add('button--disabled');
		bookBtn.disabled = true;
	});
}

function handleBookingE(single) {
	
	if (single) {
		const btn = document.querySelector('.e-add-to-cart');
		if (!btn) return;
		
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			if (btn.disabled || btn.classList.contains('button--disabled')) return;
			
			const main = document.querySelector('main.page--single-course');
			const trainingId = main?.dataset?.courseId || '';
			if (!trainingId) return;
			
			const locationId = main.dataset.locationId;
			const eventId = main.dataset.eventId;
			const allLocations = main.dataset.allLocations;
			
			const data = {
				trainingId,
				locationId,
				eventId,
				title: main.dataset.elearningTitle,
				location_name: main.dataset.elearningLocation,
				country_code: 'globe',
				start_date: main.dataset.elearningStart,
				end_date: main.dataset.elearningEnd,
				price: main.dataset.elearningAmount,
				offerToken: main.dataset.offerToken,
				currency: currencySymbols[main.dataset.elearningCurrency] ?? main.dataset.elearningCurrency,
				booking_url: document.querySelector('.e-order-btn')?.getAttribute('href') || ''
			};
			
			let uid = addToCart(trainingId, locationId, eventId, '', main.dataset.date);
			data.uid = uid;
			
			renderCartPopupTemplate(data, true);
			addMiniCartItem(data);
			updateCartMiniQuantity();
			
			btn.classList.add('button--disabled');
			btn.disabled = true;
		});
	} else {
		document.addEventListener('click', function (e) {
			const btn = e.target.closest('.e-add-to-cart');
			if (!btn) return;
			
			if (btn.disabled || btn.classList.contains('button--disabled')) return;
			
			e.preventDefault();
			
			const popup = document.querySelector('.item-cart-added');
			const popupLoader = popup.querySelector('.loader-wrp');
			popupLoader.classList.add('active');
			
			fetch(ajax_object.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
				},
				body: new URLSearchParams({
					action: 'fmtc_book_elearning',
					post_id: btn.dataset.postId,
				})
			})
				.then(response => response.json())
				.then(result => {
					
					result = result.data;
					
					const trainingId = result.courseId || '';
					const locationId = result.locationId;
					const eventId = result.eventId;
					const allLocations = result.allLocations;
					
					const data = {
						trainingId,
						locationId,
						eventId,
						title: result.elearningTitle,
						offerToken: result.offerToken,
						location_name: result.elearningLocation,
						country_code: 'globe',
						start_date: result.elearningStart,
						end_date: result.elearningEnd,
						price: result.elearningAmount,
						currency: currencySymbols[result.elearningCurrency] ?? result.elearningCurrency,
						booking_url: result.link,
					};
					
					let uid = addToCart(trainingId, locationId, eventId, allLocations, result.date);
					data.uid = uid;
					
					renderCartPopupTemplate(data, true);
					addMiniCartItem(data);
					updateCartMiniQuantity();
					
					popupLoader.classList.remove('active');
					btn.classList.add('button--disabled');
					btn.disabled = true;
					
				})
				.catch(error => {
					alert('AJAX error:' + error);
				});
			
		});
	}
}

function handleCartRemoving() {
	document.addEventListener('click', function (e) {
		const removeBtn = e.target.closest('.body-mini-cart__remove');
		if (!removeBtn) return;
		
		e.stopPropagation();
		
		const item = removeBtn.closest('.body-mini-cart__item');
		if (!item) return;
		
		const trainingId = item.dataset.courseId?.toString();
		const uid = item.dataset.uid?.toString();
		const offerToken = item.dataset.offerToken?.toString();
		
		if (!trainingId || !uid || !offerToken) return;
		
		let cart = getCart();
		
		if (!cart[trainingId]) return;
		
		for (const locKey in cart[trainingId]) {
			const entries = cart[trainingId][locKey];
			const updated = entries.filter(entry => entry.uid !== uid);
			
			if (updated.length !== entries.length) {
				if (updated.length > 0) {
					cart[trainingId][locKey] = updated;
				} else {
					delete cart[trainingId][locKey];
				}
				
				if (Object.keys(cart[trainingId]).length === 0) {
					delete cart[trainingId];
				}
				
				saveCart(cart);
				setTimeout(updateCartMiniQuantity, 100);
				item.remove();
				
				const btn = document.querySelector('.body-mini-cart__button');
				if (btn && btn.href && offerToken) {
					try {
						const url = new URL(btn.href);
						let tokens = url.searchParams.get('tokens')?.split(',').filter(Boolean) ?? [];
						
						tokens = tokens.filter(token => token !== offerToken);
						if (tokens.length > 0) {
							url.searchParams.set('tokens', tokens.join(','));
						} else {
							url.searchParams.delete('tokens');
						}
						
						btn.href = url.toString();
					} catch (e) {
						console.warn('Invalid booking URL:', e);
					}
				}
				
				break;
			}
		}
	});
}

function renderTrainingOccurrences(events, locationsMap, trainingId, popup) {
	const container = popup.querySelector('.single-course-modal__rows');
	const wrapper = popup.querySelector('.single-course-modal__rows-wrp');
	const resultsQuantity = popup.querySelector('.results-quantity');
	container.innerHTML = '';
	resultsQuantity.textContent = events.length;
	wrapper.classList.remove('end');
	if (!events.length) {
		container.innerHTML = '<p>No available training events in selected period.</p>';
		if (wrapper) wrapper.classList.remove('end');
		return;
	}
	
	const perPage = 10;
	let currentIndex = 0;
	
	const cart = getCart();
	const tId = trainingId.toString();
	const selectedEvents = cart[tId] ?? {};
	
	function renderBatch() {
		const endIndex = Math.min(currentIndex + perPage, events.length);
		for (let i = currentIndex; i < endIndex; i++) {
			const event = events[i];
			const eId = event.id.toString();
			const lId = event.location_id.toString();
			const offerToken = event.offer_token.toString();
			const isBooked = selectedEvents[lId]?.some(item => item.id === eId);
			
			const status = event.status;
			const startDate = new Date(event.start_date);
			const endDateObj = new Date(event.end_date);
			const dateOptions = {
				weekday: 'short',
				month: 'short',
				day: 'numeric'
			};
			const timeStart = startDate.toLocaleTimeString([], {
				hour: '2-digit',
				minute: '2-digit'
			});
			const timeEnd = endDateObj.toLocaleTimeString([], {
				hour: '2-digit',
				minute: '2-digit'
			});
			const formattedDate = startDate.toLocaleDateString('en-US', dateOptions);
			const note = `Starts ${timeStart} (Ends ${endDateObj.toLocaleDateString('en-US', dateOptions)} ${timeEnd})`;
			
			const locationData = locationsMap[event.location_id] ?? {};
			const locationName = locationData.name ?? `Location #${event.location_id}`;
			const countryCode = locationData.country ?? 'US';
			const priceTier = event.price_offer?.[0] ?? event.price_regular?.[0];
			const amount = priceTier?.price?.amount ?? 0;
			const currency = priceTier?.price?.currency ?? 'EUR';
			const currencySymbol = currencySymbols[currency] ?? currency;
			
			const row = document.createElement('div');
			row.className = 'course-order-row';
			row.dataset.eventId = eId;
			row.dataset.locationId = lId;
			row.dataset.offerToken = offerToken;
			row.dataset.countryCode = countryCode;
			row.dataset.locationName = locationName;
			row.dataset.startDate = event.start_date ? event.start_date.split('T')[0] : '';
			row.dataset.endDate = event.end_date ? event.end_date.split('T')[0] : '';
			row.dataset.currency = currencySymbol;
			row.dataset.price = amount;
			row.dataset.allLocations = Object.keys(locationsMap).join(',');
			if (isBooked) row.classList.add('booked');
			
			const buttonLabel = isBooked ? 'Booked' : 'Book';
			const disabledAttr = isBooked ? 'button--disabled' : '';
			
			row.innerHTML = `
				<div class="course-order-row__info ${status}">
					<div class="course-order-row__labels">
						<a href="#" class="course-order-row__label" data-status="${event.status}">
							<span>${formattedDate}</span>
						</a>
						<div class="course-order-row__note-label">${note}</div>
					</div>
					<div class="course-order-row__location">
						<div class="course-order-row__icon-location">
							<img src="${global.template_url}/dist/img/icons/flags/${countryCode}.svg" width="20" height="20" alt="${countryCode} flag" loading="lazy">
						</div>
						<span>${locationName}</span>
					</div>
				</div>
				<div class="course-order-row__actions">
					<div class="course-order-row__price">
						<div class="course-order-row__icon-price">
							<svg width="16" height="16">
								<use xlink:href="${global.template_url}/dist/img/icons/icons.svg#currency-${currency.toLowerCase()}"></use>
							</svg>
						</div>
						<span>${currencySymbol}${amount}</span>
					</div>
					<div class="course-order-row__buttons">
						<button data-popup=".item-cart-added" class="course-order-row__button booking-button button button--green button--rounded ${disabledAttr}" ${disabledAttr}>
							${buttonLabel}
						</button>
					</div>
				</div>
			`;
			const bookingButton = row.querySelector('.booking-button');
			handleBooking(bookingButton);
			container.appendChild(row);
		}
		currentIndex = endIndex;
		
		if (wrapper) {
			if (currentIndex >= events.length) {
				wrapper.classList.add('end');
			} else {
				wrapper.classList.remove('end');
			}
		}
	}
	
	renderBatch();
	
	container.addEventListener('scroll', () => {
		if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
			if (currentIndex < events.length) {
				renderBatch();
			} else {
				wrapper.classList.add('end');
			}
		} else {
			wrapper.classList.remove('end');
		}
	});
}

async function fetchCombinedExchangeRates() {
	const rates = {EUR: 1};
	
	try {
		const res1 = await fetch('https://api.frankfurter.app/latest?from=EUR&to=USD,GBP');
		const data1 = await res1.json();
		if (data1?.rates) {
			Object.assign(rates, data1.rates);
		}
	} catch (err) {
		console.warn('Frankfurter API failed:', err);
	}
	
	try {
		const res2 = await fetch('https://open.er-api.com/v6/latest/EUR');
		const data2 = await res2.json();
		if (data2?.rates?.SAR) {
			rates['SAR'] = data2.rates.SAR;
		}
	} catch (err) {
		console.warn('ER API failed (SAR fallback):', err);
	}
	
	return rates;
}

async function buildLocationsMap(locationIds) {
	const locationsMap = {};
	for (const locId of locationIds) {
		const locDetails = await fetchLocationDetails(locId);
		locationsMap[locId] = {
			name: locDetails?.entity?.name ?? `Location #${locId}`,
			country: locDetails?.entity?.country ?? 'US',
		};
	}
	return locationsMap;
}

async function fetchCourseSuggestions(trainingId, startDate, endDate, locationIds = []) {
	
	const params = new URLSearchParams({
		action: 'fetch_fmtc_suggestions',
		training_id: trainingId,
		date: `${startDate}T00:00:00.00/${endDate}T00:00:00.00`,
		locations: locationIds.join(','),
	});
	try {
		const response = await fetch(ajax_object.ajax_url + '?' + params.toString(), {method: 'GET'});
		console.log(params.toString());
		if (!response.ok) throw new Error('Fetch failed');
		return await response.json();
	} catch (e) {
		console.error('Suggestion fetch error:', e);
		return [];
	}
	
}

async function fetchCourseDetails(courseId) {
	const params = new URLSearchParams({
		action: 'fetch_fmtc_course',
		course_id: courseId,
	});
	try {
		const response = await fetch(ajax_object.ajax_url + '?' + params.toString(), {method: 'GET'});
		if (!response.ok) throw new Error('Failed to fetch course details');
		return await response.json();
	} catch (e) {
		console.error('Course details fetch error:', e);
		return null;
	}
}

async function fetchLocationDetails(locationId) {
	const params = new URLSearchParams({
		action: 'fetch_fmtc_location',
		location_id: locationId,
	});
	try {
		const response = await fetch(ajax_object.ajax_url + '?' + params.toString(), {method: 'GET'});
		if (!response.ok) throw new Error('Failed to fetch location details');
		return await response.json();
	} catch (e) {
		console.error('Location details fetch error:', e);
		return null;
	}
}

async function renderCoursePrices(courseEntity) {
	const container = document.querySelector('.prices-course-info__rows');
	const note = document.querySelector('.prices-course-info__note');
	const quantity = document.querySelector('.check-availability-quantity');
	container.innerHTML = '';
	note.textContent = '';
	
	if (!courseEntity?.locations?.length) {
		note.textContent = 'No location/price data available.';
		return;
	}
	
	const userCurrency = getCookie('currency') || 'EUR';
	const currencySymbols = {
		EUR: '€',
		USD: '$',
		GBP: '£',
		SAR: 'SAR'
	};
	
	const exchangeRates = await fetchCombinedExchangeRates();
	const today = new Date();
	const isElearning = document.querySelector('.page--single-course')?.dataset.type === 'elearning';
	const courseId = document.querySelector('.page--single-course')?.dataset.courseId;
	const currentCountry = document.querySelector('.page--single-course')?.dataset.currentCountry?.toUpperCase();
	
	const processedLocations = [];
	
	for (const location of courseEntity.locations) {
		const locId = location.id;
		const locationDetails = await fetchLocationDetails(locId);
		const locName = locationDetails?.entity?.name ?? `Location #${locId}`;
		const countryCode = locationDetails?.entity?.country ?? 'US';
		
		if (!Array.isArray(location.pricing) || location.pricing.length === 0) continue;
		
		let selectedTier = null;
		for (const pricing of location.pricing) {
			const effectDate = new Date(pricing.date_in_effect);
			if (effectDate > today) continue;
			const tier = pricing.tiers.find(t => t.min_trainees === 1);
			if (!tier?.price) continue;
			selectedTier = tier;
		}
		if (!selectedTier || !selectedTier.price) continue;
		
		const {
			amount,
			currency
		} = selectedTier.price;
		const originalSymbol = currencySymbols[currency] || currency;
		
		let convertedPrice = '';
		if (amount > 0 && currency !== userCurrency && exchangeRates[currency] && exchangeRates[userCurrency]) {
			const amountInEur = currency === 'EUR' ? amount : amount / exchangeRates[currency];
			const converted = userCurrency === 'EUR' ? amountInEur : amountInEur * exchangeRates[userCurrency];
			const userSymbol = currencySymbols[userCurrency] || userCurrency;
			convertedPrice = ` (<span data-currency="${userCurrency}">${userSymbol}</span>${converted.toFixed(2)})`;
		}
		
		processedLocations.push({
			locId,
			locName,
			countryCode,
			amount,
			originalSymbol,
			convertedPrice
		});
	}
	
	processedLocations.sort((a, b) => {
		const aIsCurrent = a.countryCode === currentCountry;
		const bIsCurrent = b.countryCode === currentCountry;
		if (aIsCurrent && !bIsCurrent) return -1;
		if (!aIsCurrent && bIsCurrent) return 1;
		return a.countryCode.localeCompare(b.countryCode);
	});
	
	let counter = 0;
	
	for (const loc of processedLocations) {
		const row = document.createElement('a');
		row.className = 'prices-course-info__row';
		row.dataset.location = loc.locId;
		
		if (isElearning && courseId) {
			const eOrderBtn = document.querySelector('.e-order-btn');
			if (eOrderBtn) row.href = eOrderBtn.getAttribute('href') || '';
			row.target = '_blank';
		} else {
			row.href = '#';
			row.dataset.popup = '.single-course-modal';
		}
		
		const flagIcon = isElearning ? 'globe' : loc.countryCode;
		
		const priceHtml = (parseFloat(loc.amount) === 0) ? `<span class="course-price">On request</span>` : `<span>${loc.originalSymbol}${loc.amount}<span class="converted">${loc.convertedPrice}</span></span>`;
		
		row.innerHTML = `
      <div class="prices-course-info__name">
        <img src="${global.template_url}/dist/img/icons/flags/${flagIcon}.svg" width="16" height="16" alt="${flagIcon} flag" loading="lazy">
        <span>${loc.locName}</span>
      </div>
      <div class="prices-course-info__value">
        ${priceHtml}
        <svg width="12" height="12">
          <use xlink:href="${global.template_url}/dist/img/icons/icons.svg#arr-bottom"></use>
        </svg>
      </div>
    `;
		
		container.appendChild(row);
		counter++;
	}
	
	if (quantity) {
		quantity.textContent = counter;
	}
	document.dispatchEvent(new Event('coursePricesRendered'));
}

window.updateCourseLocationPrices = async function () {
	const main = document.querySelector('main.page--single-course');
	if (!main) return;
	const courseId = main.dataset.courseId;
	if (!courseId) return;
	
	const result = await fetchCourseDetails(courseId);
	const entity = result?.entity;
	if (entity) {
		
		await renderCoursePrices(entity);
		
	}
	
};

document.addEventListener('DOMContentLoaded', () => {
	const compareCards = document.querySelectorAll('.compare__card');
	fetch('https://api.country.is/')
		.then(response => response.json())
		.then(async data => {
			const userCountry = data.country;
			const preferredCurrency = userCountry === 'US' ? 'USD' : userCountry === 'GB' ? 'GBP' : 'EUR';
			for (const card of compareCards) {
				const courseId = card.dataset.courseId;
				if (!courseId) continue;
				const result = await fetchCourseDetails(courseId);
				const entity = result?.entity;
				if (!entity?.locations?.length) continue;
				let matchedPrices = [];
				for (const loc of entity.locations) {
					for (const pricing of loc.pricing ?? []) {
						const tier = pricing.tiers?.find(t => t.min_trainees === 1);
						if (!tier?.price?.amount) continue;
						matchedPrices.push({
							amount: parseFloat(tier.price.amount),
							currency: tier.price.currency,
						});
					}
				}
				if (!matchedPrices.length) continue;
				let priceToShow = matchedPrices
					.filter(p => p.currency === preferredCurrency)
					.sort((a, b) => a.amount - b.amount)[0];
				if (!priceToShow) priceToShow = matchedPrices.sort((a, b) => a.amount - b.amount)[0];
				const symbol = currencySymbols[priceToShow.currency] ?? priceToShow.currency;
				const priceEl = card.querySelector('.compare__price span');
				if (priceEl) priceEl.textContent = `${symbol} ${priceToShow.amount.toFixed(2)}`;
			}
		});
});

document.addEventListener('DOMContentLoaded', function () {
	const form = document.querySelector('.check-availability-form');
	if (!form) return;
	const popup = document.querySelector('#booking-popup');
	const loader = popup.querySelector('.loader-wrp');
	const rowsContainer = popup.querySelector('.single-course-modal__rows');
	let submitAllowed = false;
	
	const submitBtns = document.querySelectorAll('.check-availability-form button[type="submit"], #book-course-btn, .content-booking-btn');
	submitBtns.forEach(btn => {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			submitAllowed = true;
			form.dispatchEvent(new Event('submit', {
				cancelable: true,
				bubbles: true
			}));
		});
	});
	
	form.addEventListener('submit', async function (e) {
		if (!submitAllowed) {
			e.preventDefault();
			return;
		}
		submitAllowed = false;
		e.preventDefault();
		
		setLoaderState(loader, true);
		popup.classList.add('loading');
		rowsContainer.innerHTML = '';
		const main = document.querySelector('main.page--single-course');
		if (!main) {
			setLoaderState(loader, false);
			popup.classList.remove('loading');
			return;
		}
		const trainingId = main.dataset.courseId;
		const locationSelect = form.querySelector('[name="locations[]"]');
		const locations = getSelectedLocations(locationSelect);
		const rawDateValue = form.querySelector('[name="date_range"]').value;
		document.querySelector('.single-course-modal__actions .calendar input').value = rawDateValue;
		const [startDate, endDate] = parseDateRange(rawDateValue);
		if (!trainingId || !startDate || !endDate || locations.length === 0) {
			setLoaderState(loader, false);
			popup.classList.remove('loading');
			console.error('Incomplete form');
			return;
		}
		const result = await fetchCourseSuggestions(trainingId, startDate, endDate, locations);
		const events = result?.data?.training_event_occurrences ?? [];
		const locationsMap = await buildLocationsMap(locations);
		setLoaderState(loader, false);
		popup.classList.remove('loading');
		rowsContainer.innerHTML = '';
		
		renderTrainingOccurrences(events, locationsMap, trainingId, popup);
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const select = document.querySelector('.page--single-course select[name="locations[]"]');
	const checkboxes = document.querySelectorAll('#booking-popup .sidebar-filters__block input[type="checkbox"]');
	if (!select || !checkboxes.length) return;
	
	const allOptions = Array.from(select.options);
	const countryOptions = allOptions.filter(opt => opt.dataset.class?.includes('_group-start'));
	
	function getCountryFromCheckboxId(id) {
		return id.startsWith('country_') ? id.replace('country_', '') : null;
	}
	
	function getLocationFromCheckboxId(id) {
		return id.startsWith('loc_') ? id.replace('loc_', '') : null;
	}
	
	function syncCheckboxesFromSelect() {
		const selectedValues = Array.from(select.selectedOptions).map(opt => opt.value);
		checkboxes.forEach(cb => {
			const locId = getLocationFromCheckboxId(cb.id);
			const countryId = getCountryFromCheckboxId(cb.id);
			if (locId) cb.checked = selectedValues.includes(locId);
			if (countryId) {
				const opt = select.querySelector(`option[value="${countryId}"]`);
				cb.checked = opt?.selected ?? false;
			}
		});
	}
	
	function syncSelectFromCheckboxes() {
		const selectedValues = [];
		const selectedCountries = [];
		
		checkboxes.forEach(cb => {
			if (cb.checked) {
				const locId = getLocationFromCheckboxId(cb.id);
				const countryId = getCountryFromCheckboxId(cb.id);
				if (locId) selectedValues.push(locId);
				if (countryId) selectedCountries.push(countryId);
			}
		});
		
		allOptions.forEach(opt => {
			const isCountry = countryOptions.includes(opt);
			if (isCountry) {
				opt.selected = selectedCountries.includes(opt.value);
			} else {
				opt.selected = selectedValues.includes(opt.value);
			}
		});
		
		select.dispatchEvent(new Event('change', {bubbles: true}));
	}
	
	checkboxes.forEach(cb => {
		cb.addEventListener('change', function () {
			console.log(1);
			const block = cb.closest('.sidebar-filters__block');
			if (!block) return;
			
			console.log(2);
			
			if (cb.id.startsWith('country_')) {
				console.log(3);
				const locCheckboxes = block.querySelectorAll('input[id^="loc_"]');
				locCheckboxes.forEach(locCb => {
					console.log(4);
					locCb.checked = cb.checked;
				});
			}
			
			if (cb.id.startsWith('loc_')) {
				const locCheckboxes = block.querySelectorAll('input[id^="loc_"]');
				const countryCb = block.querySelector('input[id^="country_"]');
				if (countryCb) {
					countryCb.checked = Array.from(locCheckboxes).every(l => l.checked);
				}
			}
			
			syncSelectFromCheckboxes?.();
		});
	});
	
	document.addEventListener('selectCallback', function (e) {
		if (e.detail.select === select) {
			syncCheckboxesFromSelect();
		}
	});
	
	syncCheckboxesFromSelect();
});

document.addEventListener('DOMContentLoaded', function () {
	const modalForm = document.querySelector('.single-course-modal__actions');
	if (!modalForm) return;
	
	const popup = document.querySelector('#booking-popup');
	const loader = popup.querySelector('.loader-wrp');
	const rowsContainer = popup.querySelector('.single-course-modal__rows');
	let currentRenderId = 0;
	let pending = false;
	
	async function renderResults(triggerByFilters = false) {
		const renderId = ++currentRenderId;
		pending = true;
		popup.classList.add('loading');
		rowsContainer.innerHTML = '';
		
		const main = document.querySelector('main.page--single-course');
		if (!main || !renderIdMatches(renderId)) return;
		
		const trainingId = main.dataset.courseId;
		const rawDateInput = modalForm.querySelector('[name="form[]"][data-datepicker]');
		const rawDateValue = rawDateInput?.value || '';
		
		const [startDate, endDate] = parseDateRange(rawDateValue);
		
		let locations = [];
		if (triggerByFilters) {
			locations = getCheckedFilterLocations(document.querySelector('#filter-locations'));
		} else {
			const selectEl = modalForm.querySelector('[name="locations[]"]');
			if (!selectEl) {
				console.warn('Select element not found');
				return;
			}
			locations = getSelectedLocations(selectEl);
		}
		
		if (!trainingId || !startDate || !endDate || !locations.length || !renderIdMatches(renderId)) return;
		
		let result;
		try {
			result = await fetchCourseSuggestions(trainingId, startDate, endDate, locations);
		} catch (e) {
			console.error(e);
			if (!renderIdMatches(renderId)) return;
			popup.classList.remove('loading');
			return;
		}
		
		if (!renderIdMatches(renderId)) return;
		
		const events = result?.data?.training_event_occurrences ?? [];
		const locationsMap = await buildLocationsMap(locations);
		if (!renderIdMatches(renderId)) return;
		
		renderTrainingOccurrences(events, locationsMap, trainingId, popup);
		popup.classList.remove('loading');
		setLoaderState(loader, false);
		pending = false;
	}
	
	function renderIdMatches(id) {
		const match = id === currentRenderId;
		if (!match && !pending) popup.classList.remove('loading');
		return match;
	}
	
	modalForm.addEventListener('submit', function (e) {
		e.preventDefault();
		setLoaderState(loader, true);
		setTimeout(() => {
			renderResults(true);
		}, 0);
	});
	
	const filters = document.querySelectorAll('#booking-popup input[type="checkbox"], [name="form[]"][data-datepicker]');
	filters.forEach(el => {
		el.addEventListener('change', () => {
			setLoaderState(loader, true);
			setTimeout(() => {
				renderResults(true);
			}, 0);
		});
	});
});

document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('click', function (e) {
		const row = e.target.closest('.prices-course-info__row');
		
		if (!row) return;
		
		const locId = row.dataset.location;
		
		if (!locId) return;
		
		const popup = document.querySelector('#booking-popup');
		const loader = popup.querySelector('.loader-wrp');
		
		if (!popup) return;
		
		const select = document.querySelector('select[name="locations[]"]');
		const checkboxes = popup.querySelectorAll('.sidebar-filters__block input[type="checkbox"]');
		
		if (!select || !checkboxes.length) return;
		
		Array.from(select.options).forEach(opt => {
			opt.selected = opt.value === locId;
		});
		
		checkboxes.forEach(cb => {
			cb.checked = cb.id === `loc_${locId}`;
		});
		
		select.dispatchEvent(new Event('change', {bubbles: true}));
		setLoaderState(loader, true);
		const submitEvent = new Event('submit', {
			cancelable: true,
			bubbles: true
		});
		const modalForm = document.querySelector('.single-course-modal__actions');
		if (modalForm) modalForm.dispatchEvent(submitEvent);
		
	});
	document.addEventListener('click', function (e) {
		const button = e.target.closest('.course-bar-btn');
		if (!button) return;
		
		e.preventDefault();
		
		const row = button.closest('.training-info-row');
		if (!row) return;
		
		const locationIdsRaw = row.dataset.locations || '';
		const trainingId = row.dataset.courseId;
		const row_title = row.querySelector('.training-info-row__title');
		
		if (!trainingId || !locationIdsRaw) return;
		
		const locationIds = locationIdsRaw.split(',').map(id => id.trim()).filter(Boolean);
		const popup = document.querySelector('#booking-popup');
		const checkboxes = popup.querySelectorAll('.sidebar-filters__block input[type="checkbox"]');
		const title = popup.querySelector('.single-course-modal__title');
		
		if (title && row_title) {
			title.textContent = row_title.textContent.trim();
		}
		
		checkboxes.forEach(cb => {
			cb.checked = false;
		});
		
		checkboxes.forEach(cb => {
			cb.addEventListener('change', function () {
				const block = cb.closest('.sidebar-filters__block');
				if (!block) return;
				
				if (cb.id.startsWith('country_')) {
					const locCheckboxes = block.querySelectorAll('input[id^="loc_"]');
					locCheckboxes.forEach(locCb => {
						locCb.checked = cb.checked;
					});
				}
				
				if (cb.id.startsWith('loc_')) {
					const locCheckboxes = block.querySelectorAll('input[id^="loc_"]');
					const countryCb = block.querySelector('input[id^="country_"]');
					if (countryCb) {
						countryCb.checked = Array.from(locCheckboxes).every(l => l.checked);
					}
				}
			});
		});
		
		locationIds.forEach(locId => {
			const checkbox = popup.querySelector(`#loc_${locId}`);
			if (checkbox) checkbox.checked = true;
		});
		syncCountriesFromLocations();
		
		const form = popup.querySelector('.single-course-modal__actions');
		if (!form) return;
		
		// remove existing fake main if any
		const existingFakeMain = document.querySelector('main.page--single-course');
		if (existingFakeMain) {
			existingFakeMain.remove();
		}
		
		// create new fake main with correct course ID
		const fakeMain = document.createElement('main');
		fakeMain.className = 'page--single-course';
		fakeMain.dataset.courseId = trainingId;
		fakeMain.dataset.allLocations = locationIds.join(',');
		if (title && row_title) {
			fakeMain.dataset.courseTitle = row_title.textContent.trim();
		}
		document.body.appendChild(fakeMain);
		
		form.dispatchEvent(new Event('submit', {
			cancelable: true,
			bubbles: true
		}));
	});
});

document.addEventListener('DOMContentLoaded', () => {
	
	handleCartRemoving();
	
	if (!document.querySelector('body.single-courses')) handleBookingE(false);
	
	const main = document.querySelector('main.page--single-course');
	if (!main || main.dataset.type !== 'elearning') return;
	
	handleBookingE(true);
	
});